var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHaskell = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 170 120",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#666"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 120 40-60L0 0h30l40 60-40 60M136.667 85l-13.334-20H170v20M116.667 55l-13.334-20H170v20"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#999",
  d: "m40 120 40-60L40 0h30l80 120h-30L95 82.5 70 120"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHaskell);
export default ForwardRef;